function getEnv(): 'development' | 'staging' | 'production' {
  if (process.env.NODE_ENV === 'development') return 'development'
  if (location.hostname.includes('stage')) return 'staging'
  return 'production'
}

function getDomain(): 'atelier' | 'dresscode' | 'showoff' {
  const host = location.hostname
  const atelier = host.endsWith('.atelierdigital.ai') || host.endsWith('.apiresq.com')
  const dresscode = host.endsWith('.dresscode.ai')
  return atelier ? 'atelier' : dresscode ? 'dresscode' : 'showoff'
}

const env = getEnv()

export const development = env === 'development'
export const staging = env === 'staging'
export const production = env === 'production'
export const app_version = process.env.RELEASE_NAME || 'unknown'
export const app_domain = getDomain()
